import { ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  children?: ReactNode;
  additionalData?: ReactNode;
  classNameTitle?: string;
};

export const PrimaryTitleBlock = ({
  title,
  description,
  children,
  additionalData,
  classNameTitle,
}: Props) => {
  return (
    <div className="bg-primary-25 rounded-lg p-4">
      <div className={classNameTitle}>
        <div>
          <p className="typography-body-bold-sm">{title}</p>
          {description && (
            <p className="typography-body-xs text-monochrome-600 mt-1">
              {description}
            </p>
          )}
        </div>
        {additionalData}
      </div>
      {children}
    </div>
  );
};
